export function formatArea(m2: number, isImperial: boolean): string {
    if (m2 == null) return null;
    return isImperial ? `${(m2 * 10.764).toFixed(1)} ft²` : `${(+m2).toFixed(1)} m²`;
}

export function formatVolume(m3: number, isImperial: boolean): string {
    if (m3 == null) return null;
    return isImperial ? `${(m3 * 35.315).toFixed(1)} ft³` : `${(+m3).toFixed(1)} m³`;
}

export function formatLength(m: number, isImperial: boolean): string {
    if (m == null) return "–";
    return isImperial ? `${(m * 3.281).toFixed(1)} ft` : `${(+m).toFixed(1)} m`;
}